import { defineMessages } from 'react-intl';

export default defineMessages({
    returnLaterButtonLabel: {
        id: 'wmic.qb.gw-portals-wizard-react.Wizard.WMICDigitalWizardPageTemplateQnB.Return Later',
        defaultMessage: 'Return Later'
    },
    rentersQuoteDisclaimer: {
        id: 'quoteandbind.common.controllers.QuoteDetails.W Insurance renters quote disclaimer',
        defaultMessage: '\n All policies underwritten by W Insurance Company are subject to certain terms and conditions. The premium provided is an estimate and is based on initial responses. This quote is subject to underwriting approval and may change. \"W Insurance\" is a trademark of W Insurance Company.'
    },
    californiaLawRequires: {
        id: 'quoteandbind.common.views.quote-details.California law requires us to inform you of the following:',
        defaultMessage: 'California law requires us to inform you of the following:'
    },
    californiaLawDisclaimer: {
        id: 'quoteandbind.common.views.quote-details.Any person who knowingly presents false or fraudulent information to obtain or amend insurance coverage or to make a claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.',
        defaultMessage: 'Any person who knowingly presents false or fraudulent information to obtain or amend insurance coverage or to make a claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.'
    },
    bottomCreditCardFee: {
        id: 'platform.paymentdetails.credit-card-details.For future installments using',
        defaultMessage: '*A processing fee of {convenienceFeeWithSymbol} will be charged for each future installment paid with a credit or debit card.'
    },
    bottomCreditCardFeeFullPayTempSupplementalFee: {
        id: 'platform.paymentdetails.credit-card-details.Total includes a Temporary Supplemental Fee full pay',
        defaultMessage: '*Total includes a Temporary Supplemental Fee of {feePercentage} of the total premium for the California FAIR Plan. A {convenienceFeeWithSymbol} credit or debit card processing fee is also included within the payment amount due today.'
    },
    bottomCreditCardFeeThreePayTempSupplementalFee: {
        id: 'platform.paymentdetails.credit-card-details.Total includes a Temporary Supplemental Fee three pay',
        defaultMessage: '*Total includes a Temporary Supplemental Fee of {feePercentage} of the total premium for the California FAIR Plan. A {convenienceFeeWithSymbol} credit or debit card processing fee is also included within the payment amount due today and will be charged for each future installment paid with a credit or debit card.'
    },
    tempSupplementalFeeDisclaimer: {
        id: 'quoteandbind.common.views.quote-details.Total includes a Temporary Supplemental Fee of',
        defaultMessage: '*Total includes a Temporary Supplemental Fee of {feePercentage} of the total premium for the California FAIR Plan.'
    }
});
